import { render, staticRenderFns } from "./PlantShowInfoTable.vue?vue&type=template&id=61f5ec70&scoped=true"
import script from "./PlantShowInfoTable.vue?vue&type=script&lang=ts"
export * from "./PlantShowInfoTable.vue?vue&type=script&lang=ts"
import style0 from "./PlantShowInfoTable.vue?vue&type=style&index=0&id=61f5ec70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f5ec70",
  null
  
)

export default component.exports